import { render } from "./BurstItem.vue?vue&type=template&id=58e36163&scoped=true&ts=true"
import script from "./BurstItem.vue?vue&type=script&lang=ts"
export * from "./BurstItem.vue?vue&type=script&lang=ts"

import "./BurstItem.vue?vue&type=style&index=0&id=58e36163&scoped=true&lang=css"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e36163"]])

export default __exports__